export default "__VITE_ASSET__D4VcNk6Q__"